<template>
  <div class="tabs-container">
    <div class="main-tabs">
      <div v-for="(tab, index) in mainTabs" :key="index" class="tab" :class="{'selected': index === activeTab}" @click="changeTab(index)">
        <span>{{ tab.label }}</span>
      </div>
    </div>
    <div class="tabs-separator">
      <span v-if="objectsTabs.length > 0">/</span>
    </div>
    <div class="objects-tabs">
      <div v-for="(tab, index) in objectsTabs" :key="index+2" class="tab" :class="{'selected': index === activeTab-2}" @click="changeTab(index+2)">
        <span>{{ tab.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TasksManagementTabs",

  props: {
    tabs: {
      type: Array,
      required: true,
    },

    activeTab: {
      type: Number,
      required: true,
    },
  },

  computed: {
    mainTabs() {
      return this.tabs.slice(0, 2);
    },

    objectsTabs() {
      return this.tabs.length > 2 ? this.tabs.slice(2) : [];
    }
  },

  methods: {
    changeTab(index) {
      this.$emit('startTabChange', index)
    }
  }
}
</script>

<style scoped>
.tabs-container,
.main-tabs,
.objects-tabs {
  display: flex;
  flex-direction: row;
}

.tabs-container {
  border-bottom: 1px solid rgba(219, 219, 224, 1);
  width: 75%;
}

.main-tabs,
.objects-tabs {
  gap: 6px;
}

span {
  font-family: Lato;
  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
  text-align: center;
  color: rgba(41, 189, 240, 1);
}

.tab {
  border-radius: 8px 8px 0 0;
  border: 1px solid rgba(41, 189, 240, 1);
  cursor: pointer;
  min-width: 100px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tab.selected {
  background-color: rgba(41, 189, 240, 1);
}

.tab.selected span {
  color: #ffffff;
}

.tabs-separator {
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabs-separator span {
  font-size: 15px;
  line-height: 15px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/TasksManagement/TasksManagementTabs.vue